var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"responsive":"","borderless":"","fields":_vm.fields,"items":_vm.contentArray},scopedSlots:_vm._u([{key:"cell(customerName)",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":_vm.itemLink(item)}},[_vm._v(" "+_vm._s(item.customerName)+" ")])]}}])}),_c('rich-text',{attrs:{"html":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }